import { ENTITLEMENTS } from "constants/entitlements"
import { useAuth } from "context/Auth"
import { useAtomValue } from "jotai"
import { loadable } from "jotai/utils"
import { chartsAtom } from "modules/studio/hooks/useOrganizationCharts"

const myChartsAtom = loadable(chartsAtom)

export function useChartAccess() {
  const { isLoginFinished, isLoggedIn, user } = useAuth()
  const state = useAtomValue(myChartsAtom)

  const amountOfCharts =
    state.state === "hasData" ? (state.data.ok?.data?.length ?? 0) : 0

  const canCreateCharts = isLoginFinished ? isLoginFinished && isLoggedIn : true
  const hasLimitReached =
    !user.isPaid() && amountOfCharts >= ENTITLEMENTS.FREE.CHARTS

  return {
    canCreateCharts,
    hasLimitReached,
    amountOfCharts,
  }
}
